<script setup lang="ts">
import WalletManagementDetailContainer from './containers/WalletManagementDetailContainer.vue'
</script>

<template>
  <WalletManagementDetailContainer />
</template>
